import styled from 'styled-components'
import { Menu, MenuItem, MenuList } from 'pcln-menu'

const StyledMenu = styled(Menu)`
  ${MenuList} {
    width: 300px;
    margin-top: -16px;
  }
`

const StyledMenuItem = styled(MenuItem)`
  font-weight: 400 !important;
`

export { StyledMenu, StyledMenuItem }
